import { map } from "ramda";

export default (list, translationKey) =>
  function() {
    return map(
      (value) => ({
        value,
        text: this.$t(`${translationKey}.${value}`),
      }),
      list
    );
  };
